'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var add = require('./add.js');

var addAll = require('./add-all.js');

var ls = require('./ls.js');

var rm = require('./rm.js');

var rmAll = require('./rm-all.js');

var PinAPI = function PinAPI(_ref2) {
  var codecs = _ref2.codecs,
      repo = _ref2.repo;

  _classCallCheck(this, PinAPI);

  var addAll$1 = addAll.createAddAll({
    codecs: codecs,
    repo: repo
  });
  this.addAll = addAll$1;
  this.add = add.createAdd({
    addAll: addAll$1
  });
  var rmAll$1 = rmAll.createRmAll({
    codecs: codecs,
    repo: repo
  });
  this.rmAll = rmAll$1;
  this.rm = rm.createRm({
    rmAll: rmAll$1
  });
  this.ls = ls.createLs({
    codecs: codecs,
    repo: repo
  });
  this.remote = {
    add: function add(cid) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Promise.reject(new Error('Not implemented'));
    },
    ls: function () {
      var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                return _context.abrupt("return", Promise.reject(new Error('Not implemented')));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function ls(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    rm: function rm(query) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Promise.reject(new Error('Not implemented'));
    },
    rmAll: function rmAll(query) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Promise.reject(new Error('Not implemented'));
    },
    service: {
      add: function add(name, credentials) {
        return Promise.reject(new Error('Not implemented'));
      },
      rm: function rm(name) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Promise.reject(new Error('Not implemented'));
      },
      ls: function ls() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Promise.reject(new Error('Not implemented'));
      }
    }
  };
};

exports.PinAPI = PinAPI;